import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Navigation, Footer, Home, About, Menu } from "./components";
function App() {
  return (
      <Router>
        {/* <Navigation /> */}
        <Switch>
          <Route path="/" exact component={() => <Home />} />
          <Route path="/about" exact component={() => <About />} />
          <Route path="/menu" exact component={() => <Menu />} />
        </Switch>
        <Footer />
      </Router>
  );
}

export default App;
